import Constants from "../../utils/constants";
import { Link } from "react-router-dom";
import { NavLink } from "../../components/common/NavLink";
import React from "react";

import Notification from "../../components/common/Notification";
import GlobalLoading from "../../components/common/GlobalLoading";
import { useGlobalStore } from "../../utils/global";

const WithMainLayout = (PageComponent) => {
  return function WithPage({ ...props }) {
    return (
      <>
        <GlobalLoading />
        <PageComponent />
      </>
    );
  };
};

export default WithMainLayout;
